import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import getEmployeeTypes from "../../services/getEmployeeTypes";
import getDepartmentServices from "../../services/getDepartments";
import getLocationServices from "../../services/getLocationServices";
import getEmployeeStatusServices from "../../services/getEmployeeStatusServices";
import getWorkingDayTypeServices from "../../services/getWorkingDayTypeServices";
import getLeavePolicyServices from "../../services/getLeavePolicyServices";
import getHolidayCalenderServices from "../../services/getHolidayCalenderServices";
import generatePasswordServices from "../../services/generatePasswordServices";
import CountryPhoneCodeService from "../../services/countryPhoneCodeService";
import getLeaveApprovals from "../../services/getLeaveApproval";
import { HEADERS, getOrgId, CheckUserEmail, EmployeeCodeCheck } from "../api";
import createUserAccounts from "../../services/CreateUserAccount";
import getRoles from "../../services/getRole";
import { Link } from "react-router-dom";
import axios from "axios";

let firstFormValues = {};
let secondFormValues = {};
let thirdFormValues = {};

function AddUser() {
  const [errorMessage, setErrorMessage] = useState("");

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (
        file.type === "application/vnd.ms-excel" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        console.log("Selected Excel file:", file);
      } else {
        console.log("Please select a valid Excel file.");
      }
    }
  };

  const [step, setStep] = useState(1);
  const nextStep = () => {
    setStep(step + 1);
  };

  const prevStep = () => {
    setStep(step - 1);
  };

  const renderForm = () => {
    switch (step) {
      case 1:
        return <QuickInfoForm nextStep={nextStep} />;
      case 2:
        return <PersonalInfoForm nextStep={nextStep} prevStep={prevStep} />;
      case 3:
        return <OfficialInfoForm nextStep={nextStep} prevStep={prevStep} />;
      case 4:
        return <DatesForm prevStep={prevStep} />;
      default:
        return null;
    }
  };

  return (
    <div>
      <div>
        <span className="breadcrumb d-flex gap-2">
          <a className="previou-link text-decoration-none" href="/users">
            Employee List
          </a>
          <span>/</span>
          <span className="current-link text-decoration-none">
            Add Employee
          </span>
        </span>
      </div>
      <div className="pb-3 d-flex justify-content-between">
        <h5 className="title">Add Employee</h5>
        <input
          id="file-upload"
          type="file"
          accept=".xls, .xlsx"
          style={{ display: "none" }}
          onChange={handleFileUpload}
        />
      </div>
      {renderForm()}
    </div>
  );
}
const QuickInfoForm = ({ nextStep }) => {
  const [usersRole, setUsersRole] = useState([]);
  const handleNext = () => {
    nextStep();
  };
  const [formData, setFormData] = useState({
    last_name: "",
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    formState: { errors: errorsForm1 },
    trigger,
    setValue,
    clearErrors,
  } = useForm({
    defaultValues: {
      first_name: "",
      last_name: formData.last_name?.trim() ? formData.last_name : null,
      email: "",
      users_password: "",
      users_role: "",
    },
  });

  const onSubmitFirstForm = async (data) => {
    const isValid = await trigger([
      "first_name",
      "last_name",
      "email",
      "users_password",
      "users_role",
    ]);
    if (isValid) {
      handleNext();
      console.log("First form data>>>111:", data);
      firstFormValues = data;
    }
  };
  const generate_password = async () => {
    const response = await generatePasswordServices();
    setValue("users_password", response.data);
    clearErrors("users_password");
  };

  useEffect(() => {
    const companySize = async () => {
      const response = await getRoles();

      if (response.response_code === "0000") {
        console.log("rolwes", response);

        setUsersRole(response.data);
      } else {
        setUsersRole([{ role_id: "", role_name: "" }]);
      }
    };
    companySize();
  }, []);
  function checkEmail(event) {
    const userEmail = event.target.value;

    fetch(CheckUserEmail, {
      method: "POST",
      headers: HEADERS,
      body: JSON.stringify({ email: userEmail }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("res", data);
        if (data.response_code === "0000") {
          setErrorMessage("");
        } else if (data.response_code === "5000") {
          setErrorMessage("User email already exists!");
        } else if (data.response_code === "2006") {
          setErrorMessage("User email already exists!");
        } else {
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  const [errorMessage, setErrorMessage] = useState("");
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmitFirstForm)}>
        <div className="border rounded">
          <div className="border-bottom justify-content-center d-flex  p-2 ">
            <h5 className="title ">Quick Information</h5>
          </div>
          <div className="input-form p-4">
            <div className="row d-flex">
              <div className="col-md-6 pr-3">
                <div className="form-group">
                  <label>First Name</label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Enter your first name"
                    {...register("first_name", {
                      required: "First Name is required",
                    })}
                  />
                  {errors.first_name && (
                    <span className="warning">
                      {errors.first_name?.message}
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label>Last Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter your last name"
                    {...register("last_name", {})}
                  />
                  {errors.last_name && (
                    <span className="warning">{errors.last_name?.message}</span>
                  )}
                </div>
                <div className="form-group">
                  <label>Email Address</label>
                  <input
                    className="form-control"
                    type="email"
                    placeholder="Enter your email"
                    {...register("email", {
                      required: "Email is required",
                      pattern: {
                        value: /^\S+@\S+$/i,
                        message: "Please enter a valid email address",
                      },
                    })}
                    onBlur={(e) => {
                      setErrorMessage("");
                      checkEmail(e);
                    }}
                  />
                  {errorsForm1.response && (
                    <span
                      style={{ color: "red", fontSize: "14px" }}
                      className="warning"
                    >
                      {errorsForm1.response.response_description}
                    </span>
                  )}
                  {errorMessage && (
                    <span
                      style={{ color: "red", fontSize: "14px" }}
                      className="warning"
                    >
                      {errorMessage}
                    </span>
                  )}
                </div>
              </div>
              <div className="col-md-6 pl-3">
                <div className="form-group">
                  <label htmlFor="">User Role</label>
                  <select
                    className="form-select"
                    {...register("users_role", {
                      required: "User role is required",
                    })}
                  >
                    <option value="" disabled>
                      Select user role
                    </option>
                    {usersRole
                      .filter(
                        (option) =>
                          option.role_name !== "Root User" &&
                          option.role_name !== "Super User"
                      )
                      .map((option, index) => (
                        <option key={index} value={option.role_id}>
                          {option.role_name}
                        </option>
                      ))}
                  </select>

                  {errors.users_role && (
                    <span className="warning">
                      {errors.users_role?.message}
                    </span>
                  )}
                </div>

                <div className="form-group mt-2">
                  <label htmlFor="">Password</label>
                  <input
                    type="text"
                    placeholder="Enter your password"
                    {...register("users_password", {
                      required: "Password is required",
                      minLength: {
                        value: 4,
                        message: "Password should have at least 4 characters",
                      },
                    })}
                  />

                  {errors.users_password && (
                    <span className="warning">
                      {errors.users_password?.message}
                    </span>
                  )}
                </div>
                <button
                  className=" add-button"
                  style={{ cursor: "pointer" }}
                  onClick={generate_password}
                >
                  Generate Password
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="button-next mt-3">
          <button className="button-pre">Next</button>
        </div>
      </form>
    </div>
  );
};

const PersonalInfoForm = ({ nextStep, prevStep }) => {
  const [employeeType, setEmployeeType] = useState([]);
  const [department, setDepartment] = useState([
    { dept_id: "", dept_name: "" },
  ]);
  const [userLocation, setUserLocation] = useState([
    { location_id: "", location_name: "" },
  ]);
  const [employeeStatus, setEmployeeStatus] = useState([
    { employee_status_id: "", employee_status_name: "" },
  ]);
  const [workingDayType, setWorkingDayType] = useState([
    {
      working_id: "",
      hours_per_day: "",
    },
  ]);

  const [leavePolicy, setLeavePolicy] = useState([
    {
      leave_policy_id: "",
      leave_policy_name: "",
    },
  ]);
  const [holidayType, setHolidayType] = useState([
    { holiday_calendar_id: "", calendar_name: "" },
  ]);
  const [errorMessage, setErrorMessage] = useState("");

  const [forcepasswordchange, setForcepasswordchange] = useState([]);
  useEffect(() => {
    const employeeTypes = async () => {
      const response = await getEmployeeTypes();
      if (response.response_code === "0000") {
        setEmployeeType(response.data);
      } else {
        setEmployeeType([
          {
            employee_type_id: "",
            employee_type_name: "",
          },
        ]);
      }
    };
    employeeTypes();
    const employeeManagers = async () => {};
    employeeManagers();

    const departments = async () => {
      const response = await getDepartmentServices();
      if (response.response_code === "0000") {
        setDepartment(response.data);
      } else {
        setDepartment([{ dept_id: "", dept_name: "" }]);
      }
    };
    departments();

    const userLocations = async () => {
      const response = await getLocationServices();
      if (response.response_code === "0000") {
        setUserLocation(response.data);
      } else {
        setUserLocation([{ location_id: "", location_name: "" }]);
      }
    };
    userLocations();

    const employStatus = async () => {
      const response = await getEmployeeStatusServices();
      if (response.response_code === "0000") {
        setEmployeeStatus(response.data);
      } else {
        setEmployeeStatus([
          { employee_status_id: "", employee_status_name: "" },
        ]);
      }
    };
    employStatus();

    const workingDayTypes = async () => {
      const response = await getWorkingDayTypeServices();
      if (response.response_code === "0000") {
        setWorkingDayType(response.data);
      } else {
        setWorkingDayType([
          {
            working_id: "",
            hours_per_day: "",
          },
        ]);
      }
    };
    workingDayTypes();
    const leavePolicies = async () => {
      const response = await getLeavePolicyServices();
      if (response.response_code === "0000") {
        setLeavePolicy(response.data);
      } else {
        setLeavePolicy([
          {
            leave_policy_id: "",
            leave_policy_name: "",
          },
        ]);
      }
    };
    leavePolicies();

    const holidayTypes = async () => {
      const response = await getHolidayCalenderServices();
      console.log("getHolidayCalenderServices=======", response);
      if (response.response_code === "0000") {
        setHolidayType(response.data);
      } else {
        setHolidayType([{ holiday_calendar_id: "", calendar_name: "" }]);
      }
    };
    holidayTypes();

    const leaveApprovalBy = async () => {
      const response = await getLeaveApprovals();
      const datas = [
        { forcepasswordchange_id: true, forcepasswordchange_value: "True" },
        { forcepasswordchange_id: false, forcepasswordchange_value: "False" },
      ];
      if (datas) {
        console.log("getHolidayCalenderServices>>>>>>>>>>>>", response);
        setForcepasswordchange(datas);
      } else {
        setForcepasswordchange([
          { forcepasswordchange_id: "", forcepasswordchange_value: "" },
        ]);
      }
    };

    leaveApprovalBy();
  }, []);

  const handleNext = () => {
    nextStep();
  };

  const handlePrev = () => {
    prevStep();
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    trigger,
  } = useForm({
    defaultValues: {
      employee_code: "",
      job_title: "",
      employee_type: "",
      department: "",
      user_location: "",
      employee_status: "",
      leave_policy: "",
      force_password_change: true,
      holiday_type: "",
      is_head: "",
    },
  });

  const onSubmitSecondForm = async (data) => {
    const isValid = await trigger([
      "department",
      "employee_code",
      "employee_status",
      "force_password_change",
      "employee_type",
      "holiday_type",
      "is_head",
      "job_title",
      "leave_policy",
      "user_location",
    ]);
    if (isValid) {
      handleNext();
      console.log("onSubmitSecondForm>>>>", data);

      const datas = data;
      datas.is_head =
        datas.is_head === "true"
          ? true
          : datas.is_head === "false"
          ? false
          : false;
      datas.force_password_change =
        datas.force_password_change === "true"
          ? true
          : datas.force_password_change === "false"
          ? false
          : false;
      secondFormValues = datas;
    }
  };
  const handleEmployeeCodeCheck = async (code) => {
    if (!code.trim()) {
      setErrorMessage(""); // Clear any previous error
      return;
    }

    const requestBody = {
      organization_id: "00",
      employee_code: code,
    };

    try {
      const response = await axios.post(EmployeeCodeCheck, requestBody, {
        headers: HEADERS,
      });

      const { response_code, response_description } = response.data;

      if (response_code === "0000") {
        setErrorMessage(""); // No error, clear it
      } else if (response_code === "2006") {
        setErrorMessage(response_description); // Show "already exists" error
      } else {
        setErrorMessage(response_description); // Other warnings
      }
    } catch (err) {
      console.error("API Error:", err);
      setErrorMessage("Could not validate employee code.");
    }
  };

  const isHead = [
    {
      id: true,
      is_heads: "Yes",
    },
    {
      id: false,
      is_heads: "No",
    },
  ];

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmitSecondForm)}>
        <div className="border rounded">
          <div className="border-bottom justify-content-center d-flex p-2">
            <h5 className="title">Official Information</h5>
          </div>
          <div className="input-form p-4">
            <div className="row d-flex">
              <div className="col-md-6 pr-3">
                <div className="form-group">
                  <label htmlFor="">Department</label>
                  <select
                    className="form-select"
                    {...register("department", {
                      required: "Department is required",
                    })}
                  >
                    <option value="" disabled>
                      Select department
                    </option>
                    {department.map((option, index) => (
                      <option key={index} value={option.dept_id}>
                        {option.dept_name}
                      </option>
                    ))}
                  </select>
                  {errors.user_location && (
                    <span className="warning">
                      {errors.department?.message}
                    </span>
                  )}
                </div>
                <div className="form-group mt-2">
                  <label>Employee code</label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Enter employee code"
                    {...register("employee_code", {
                      required: "Employee code is required",
                    })}
                    onBlur={(e) => handleEmployeeCodeCheck(e.target.value)}
                  />

                  {errors.employee_code && (
                    <span
                      style={{ color: "red", fontSize: "14px" }}
                      className="warning"
                    >
                      {errors.employee_code.message}
                    </span>
                  )}

                  {errorMessage && (
                    <span
                      style={{ color: "red", fontSize: "14px" }}
                      className="warning"
                    >
                      {errorMessage}
                    </span>
                  )}
                </div>
                <div className="form-group mt-2">
                  <label>Job title</label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Enter job title"
                    {...register("job_title", {
                      required: "Job title is required",
                    })}
                  />
                  {errors.job_title && (
                    <span className="warning">{errors.job_title?.message}</span>
                  )}
                </div>
                <div className="form-group mt-2">
                  <label htmlFor="">Employee Type</label>
                  <select
                    className="form-select"
                    {...register("employee_type", {
                      required: "Employee type is required",
                    })}
                  >
                    <option value="" disabled>
                      Select employee type
                    </option>
                    {employeeType.map((option, index) => (
                      <option key={index} value={option.employee_type_id}>
                        {option.employee_type_name}
                      </option>
                    ))}
                  </select>
                  {errors.employee_type && (
                    <span className="warning">
                      {errors.employee_type?.message}
                    </span>
                  )}
                </div>

                <div className="form-group mt-2">
                  <label htmlFor="">Location</label>
                  <select
                    className="form-select"
                    {...register("user_location", {
                      required: "Location is required",
                    })}
                  >
                    <option value="" disabled>
                      Select location
                    </option>
                    {userLocation.map((option, index) => (
                      <option key={index} value={option.location_id}>
                        {option.location_name}
                      </option>
                    ))}
                  </select>
                  {errors.user_location && (
                    <span className="warning">
                      {errors.user_location?.message}
                    </span>
                  )}
                </div>

                <br></br>
              </div>

              <div className="col-md-6 pl-3">
                <div className="form-group">
                  <label htmlFor="">Employee status</label>
                  <select
                    className="form-select"
                    {...register("employee_status", {
                      required: "Employee status is required",
                    })}
                  >
                    <option value="" disabled>
                      Select employee status
                    </option>
                    {employeeStatus.map((option, index) => (
                      <option key={index} value={option.employee_status_id}>
                        {option.employee_status_name}
                      </option>
                    ))}
                  </select>
                  {errors.employee_status && (
                    <span className="warning">
                      {errors.employee_status?.message}
                    </span>
                  )}
                </div>
                <div className="form-group mt-2">
                  <label htmlFor="">Leave policy</label>
                  <select
                    className="form-select"
                    {...register("leave_policy", {
                      required: "Leave policy is required",
                    })}
                  >
                    <option value="" disabled>
                      Select leave policy
                    </option>
                    {leavePolicy.map((option, index) => (
                      <option key={index} value={option.leave_policy_id}>
                        {option.leave_policy_name}
                      </option>
                    ))}
                  </select>
                  {errors.leave_policy && (
                    <span className="warning">
                      {errors.leave_policy?.message}
                    </span>
                  )}
                </div>
                <div className="form-group mt-2">
                  <label htmlFor="">Holiday type</label>
                  <select
                    className="form-select"
                    {...register("holiday_type", {
                      required: "Holiday type is required",
                    })}
                  >
                    <option value="" disabled>
                      Select holiday type
                    </option>
                    {holidayType.map((option, index) => (
                      <option key={index} value={option.holiday_calendar_id}>
                        {option.calendar_name}
                      </option>
                    ))}
                  </select>
                  {errors.holiday_type && (
                    <span className="warning">
                      {errors.holiday_type?.message}
                    </span>
                  )}
                </div>

                <div className="form-group mt-2">
                  <label htmlFor="">Is Head</label>
                  <select
                    className="form-select"
                    {...register("is_head", { required: "IsHead is required" })}
                  >
                    <option value="" disabled>
                      Choose option
                    </option>
                    {isHead.map((option, index) => (
                      <option key={index} value={option.id}>
                        {option.is_heads}
                      </option>
                    ))}
                  </select>
                  {errors.is_head && (
                    <span className="warning">{errors.is_head?.message}</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button-next mt-3">
          <button className="button-previous rounded" onClick={handlePrev}>
            Previous
          </button>
          <button className="button-pre">Next</button>
        </div>
      </form>
    </div>
  );
};

const OfficialInfoForm = ({ nextStep, prevStep }) => {
  const [countryPhonrCode, setCountryPhonrCode] = useState([]);
  const [formData, setFormData] = useState({
    address_2: "",
  });
  const handleNext = () => {
    nextStep();
  };

  const handlePrev = () => {
    prevStep();
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    trigger,
  } = useForm({
    defaultValues: {
      ...formData,
      gender: "",
      address_1: "",
      address_2: formData.address_2?.trim() ? formData.address_2 : null, // Handle trimming and setting to null
      user_state: "active",
      city: "Bhutan",
      zip_code: "11001",
      country: "",
      phone_no: "",
    },
  });

  const onSubmitThirdForm = async (data) => {
    const isValid = await trigger([
      "address_1",
      "address_2",
      "city",
      "country",
      "gender",
      "phone_no",
      "user_state",
      "zip_code",
      "country_code",
    ]);
    if (isValid) {
      handleNext();
      console.log("ThirdForm Data", data);
      thirdFormValues = data;
    }
  };

  const gender = [
    {
      id: "Male",
      gender: "Male",
    },
    {
      id: "Female",
      gender: "Female",
    },
    {
      id: "Others",
      gender: "Others",
    },
  ];

  useEffect(() => {
    const getCountriesPhoneCode = async () => {
      const response = await CountryPhoneCodeService();
      if (response.response_code === "0000") {
        setCountryPhonrCode(response.data);
        // console.log("=================>>>>", response)
      } else {
        setCountryPhonrCode([{ country_code: "", country_name: "" }]);
      }
    };
    getCountriesPhoneCode();
  });

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmitThirdForm)}>
        <div className="border rounded">
          <div className="border-bottom justify-content-center d-flex p-2">
            <h5 className="title">Personal Information</h5>
          </div>
          <div className="input-form p-4">
            <div className="row d-flex">
              <div className="col-md-6 pr-3">
                <div className="form-group">
                  <label htmlFor="">Country</label>
                  <select
                    className="form-select"
                    {...register("country", {
                      required: "Country is required",
                    })}
                  >
                    <option value="" disabled selected>
                      Choose Country
                    </option>
                    {countryPhonrCode.map((option, index) => (
                      <option key={index} value={option.country_name}>
                        {option.country_name}
                      </option>
                    ))}
                  </select>
                  {errors.country && (
                    <span className="warning">{errors.country?.message}</span>
                  )}
                </div>
                <div className="form-group mt-2">
                  <label>Dzongkhag</label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Enter dzongkhag"
                    {...register("address_1", {
                      required: "Dzongkhag is required",
                    })}
                  />
                  {errors.address_1 && (
                    <span className="warning">{errors.address_1?.message}</span>
                  )}
                </div>
                <div className="form-group mt-2">
                  <label>Present Address </label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Enter present address"
                    {...register("address_2", {})}
                  />
                  {errors.address_2 && (
                    <span className="warning">{errors.address_2?.message}</span>
                  )}
                </div>
              </div>
              <div className="col-md-6 pl-3">
                <div className="form-group">
                  <label htmlFor="">Gender</label>
                  <select
                    className="form-select"
                    {...register("gender", { required: "Country is required" })}
                  >
                    <option value="" disabled selected>
                      Choose option
                    </option>
                    {gender.map((option, index) => (
                      <option key={index} value={option.id}>
                        {option.gender}
                      </option>
                    ))}
                  </select>
                  {errors.gender && (
                    <span className="warning">{errors.gender?.message}</span>
                  )}
                </div>
                <div
                  style={{ display: "flex", flexDirection: "row", gap: "2rem" }}
                >
                  <div style={{ width: "50%", height: "40%" }}>
                    <div className="form-group mt-2">
                      <label>Country Code</label>
                      <select
                        className="form-select"
                        {...register("country_code", {
                          required: "Country is required",
                        })}
                      >
                        <option value="" disabled>
                          Choose Code
                        </option>
                        {countryPhonrCode.map((option, index) => (
                          <option key={index} value={option.country_code}>
                            {option.country_code}
                          </option>
                        ))}
                      </select>
                      {errors.country_code && (
                        <span className="warning">
                          {errors.country_code?.message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div style={{ width: "70%" }}>
                    <div className="form-group mt-2 ">
                      <label>Phone Number</label>
                      <input
                        className="form-control"
                        {...register("phone_no", {
                          required: "Phone number is required",
                        })}
                        type="tel"
                        placeholder="Enter phone number"
                      />
                      {errors.phone_no && (
                        <span className="warning">
                          {errors.phone_no?.message}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button-next mt-3">
          <button className="button-previous rounded" onClick={handlePrev}>
            Previous
          </button>
          <button className="button-pre">Next</button>
        </div>
      </form>
    </div>
  );
};
const DatesForm = ({ prevStep }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    seperation_date: "",
  });
  const Adduser = () => {
    Swal.fire({
      title: "Add Confirmation",
      text: "Are you sure you want to add Employee?",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "grey",
      confirmButtonText: "Add",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Success!",
          text: this.response.response_description,
          icon: "success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "swal-custom-confirm-btn",
          },
        }).then(() => {
          window.location.reload();
        });
      }
    });
  };

  const handlePrev = () => {
    prevStep();
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    //watch,
    trigger,
    //setValue,
  } = useForm({
    defaultValues: {
      dob: "",
      hire_date: "",
      separation_date: formData.separation_date?.trim()
        ? formData.separation_date
        : null,
    },
    createUserAccounts,
  });

  const onSubmitFourthForm = async (data) => {
    try {
      const isValid = await trigger(["dob", "hire_date", "separation_date"]);
      const OrgID = getOrgId();

      if (isValid) {
        const combinedData = {
          ...firstFormValues,
          ...secondFormValues,
          ...thirdFormValues,
          ...data,
          organization_id: OrgID,
        };

        const response = await createUserAccounts(JSON.stringify(combinedData));

        if (response?.response_code === "0000") {
          Swal.fire({
            title: "Success!",
            text: response.response_description,
            icon: "success",
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "swal-custom-confirm-btn",
            },
          }).then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire({
            title: "Error",
            text: response?.response_description || "Something went wrong.",
            icon: "error",
          });
        }
      }
    } catch (error) {
      console.error("Error in onSubmitFourthForm:", error);
      Swal.fire({
        title: "Error",
        text: "An unexpected error occurred while submitting the form.",
        icon: "error",
      });
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmitFourthForm)}>
        <div className="border rounded">
          <div className="border-bottom justify-content-center d-flex p-2">
            <h5 className="title">Date</h5>
          </div>
          <div className="input-form p-4">
            <div className="row d-flex">
              <div className="col-md-6 pr-3">
                <div className="form-group date-form boder rounded">
                  <label>Hire date</label> <br />
                  <input
                    className="form-control"
                    type="date"
                    {...register("hire_date", {
                      required: "Hire date is required",
                    })}
                  />
                </div>

                <div className="form-group date-form boder rounded mt-2">
                  <label>Seperation date</label> <br />
                  <input
                    className="form-control"
                    type="date"
                    {...register("separation_date")}
                  />
                  {errors.separation_date && (
                    <span className="warning">
                      {errors.separation_date?.message}
                    </span>
                  )}
                </div>

                <div className="form-group date-form boder rounded mt-2">
                  <label>Date of birth</label>
                  <input
                    className="form-control"
                    type="date"
                    {...register("dob", {
                      required: "Date of birth is required",
                    })}
                  />
                  {errors.dob && (
                    <span className="warning">{errors.dob?.message}</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="button-next mt-3">
          <button className="button-previous" onClick={handlePrev}>
            Previous
          </button>
          <button className="button-pre" onClick={Adduser}>
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddUser;
